import React from 'react';

import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {deAuthorizeToken} from '../../ducks/auth';

import Dropdown from '../../components/dropdown/Dropdown';

import userIcon from './assets/user-icon.svg';
import ChannelLink from '../channelUtils/ChannelLink';
import withChannelFormatters from '../channelUtils/withChannelFormatters';

@injectIntl
@withChannelFormatters
@connect(({auth, user}) => ({token: auth.token, userProfile: user.profile}))
export default class UserDropdown extends React.PureComponent {
  render() {
    const {intl, dispatch, token, userProfile, channelFormatters} = this.props;

    if (!token || !userProfile) {
      return false;
    }

    return (
      <Dropdown>
        <Dropdown.Item active={true}>
          <div className="dropdown__icon">
            <img src={userIcon} alt={intl.formatMessage({id: 'section.user-dropdown.icon'})}/>
          </div>
          {userProfile.username.toUpperCase()}
        </Dropdown.Item>

        <Dropdown.Item component={ChannelLink} to="/profile/">
          {intl.formatMessage({id: 'section.user-dropdown.profile'})}
        </Dropdown.Item>

        <Dropdown.Item component={ChannelLink} to="/profile/orders">
          {intl.formatMessage({id: 'section.user-dropdown.orders'})}
        </Dropdown.Item>

        <Dropdown.Item
          onClick={() => {
            dispatch(deAuthorizeToken(token));
            browserHistory.push(channelFormatters.link('/'));
          }}
        >
          {intl.formatMessage({id: 'section.user-dropdown.sign-out'})}
        </Dropdown.Item>
      </Dropdown>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/userDropdown/UserDropdown.js